const styles = theme => ({
  certificationContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
  title: {
    fontSize: '16px',
    fontWeight: 500,
  },
  cardTitle: {
    fontSize: '16px',
    fontWeight: 500,
    marginTop: '20px',
    textAlign: 'center',
  },
  description: {
    fontSize: '14px',
    fontWeight: 400,
    color: '#637381',
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '16px',
  },
  bannerContainer: {
    width: '100%',
    height: '260px',
    borderRadius: '16px',
    border: '1px solid #E0E0E0',
    display: 'flex',
    flexDirection: 'row',
    backgroundImage: `url('/assets/upgrade-ai-creator-banner.png')`,
    backgroundPosition: 'right',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain',
    marginTop: theme.spacing(2),
  },
  bannerContent: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'left',
    width: '240px',
    height: '260px',
    gap: '16px',
    textAlign: 'center',
    marginLeft: '50px',
  },
  bannerText: {
    color: '#002E47',
    fontWeight: 500,
    fontSize: '18px',
    textAlign: 'left',
  },
  bannerSubText: {
    color: '#002E47',
    fontSize: '16px',
    textAlign: 'left',
  },
})

export default styles
